import type { FC } from 'react'

import { StyledText } from '@skytech/ui'
import { Td } from '@skytech/ui/Table/Td'

import Highlight from '@/components/Highlight'
import { useLocalDate } from '@/hooks/use-local-date'
import { useProfile } from '@/hooks/user'
import type { LogSmsPush } from '@/modules/admin/resources'

export const SMSLogsListItem: FC<LogSmsPush & { searchFilter: string; onClick: () => void }> = ({
  sent,
  sender,
  message,
  receivers,
  isPrivate,
  searchFilter,
  onClick,
}) => {
  const { formatDate } = useLocalDate()
  const profile = useProfile()

  return (
    <tr
      className="cursor-pointer hover:bg-[#f0f0f0]"
      onClick={() => onClick()}
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter') onClick()
      }}
    >
      <Td className="hidden w-2/12 md:table-cell">
        <Highlight
          pattern={searchFilter}
          text={formatDate({ date: sent, locale: profile?.locale })}
        />
      </Td>
      <Td className="hidden w-2/12 md:table-cell">
        <Highlight pattern={searchFilter} text={sender} />
      </Td>
      <Td className="hidden w-1/12 text-right md:table-cell">
        <StyledText>
          <Highlight pattern={searchFilter} text={receivers?.toString()} />
        </StyledText>
      </Td>
      <Td className="hidden w-2/12 md:table-cell">
        <Highlight pattern={searchFilter} text={isPrivate ? 'private' : 'public'} />
      </Td>
      <Td className="w-5/12 truncate">
        <Highlight pattern={searchFilter} text={message} />
      </Td>
    </tr>
  )
}
